import React from "react";
import { stepFiveData } from "./stepData";
import { Link, Typography } from "@mui/material";
import tongueOut from "../../../../../Assets/Images/tongue-out.webp";

const StepFive = () => {
  return (
    <>
      <div>
        <div className=" mt-3 d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: "23.8532px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepFiveData[0].heading}
          </Typography>
        </div>
        <ol
          style={{
            fontSize: 16,
            lineHeight: "24px",
            letterSpacing: "0.08px",
            fontWeight: 500,
            fontFamily: "'Archivo',sans-serif",
          }}
          className="mt-3 mb-0"
        >
          <li className="mt-2">
            Visit the Car Loan EMI Calculator page on
            <Link
              sx={{
                fontSize: 16,
                lineHeight: "24px",
                letterSpacing: "0.08px",
                fontWeight: 500,
                fontFamily: "'Archivo',sans-serif",
              }}
              href="https://www.hdfcbank.com/"
              variant="body2"
              underline="hover"
              target="_blank"
            >
              HDFC Bank’s website.
            </Link>{" "}
            .
          </li>
          <li className="mt-2">Select the Car Loan option.</li>
          <li className="mt-2">
            Enter your loan amount, interest rate, and preferred loan tenure.
          </li>
          <li className="mt-2">
            Instantly view your EMI, total interest, and total repayment.
          </li>
          <li className="mt-2 mb-0">
            Adjust the parameters to explore different financial scenarios and
            find the best fit for your budget.
          </li>
        </ol>
        <div className="tips mt-4 ">
          <div id="border_line"></div>
          <div id="tip__container" className="px-4 py-4">
            <div className="px-3 py-2">
              <div className="d-flex gap-2 align-items-center">
                <img src={tongueOut} alt="" style={{ width: 30, height: 30 }} />
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#59266D",
                    // color: "yellow",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  MinEmi Tip:
                </Typography>
              </div>
              <div className="mt-2">
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#1F1F1F",
                    // color: "#f8f8f8",

                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  {stepFiveData[0].tip}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepFive;
